import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'Article3up',
})(({ spacing, breakpoints, brandColors }) => ({
  spacingContainer: {
    backgroundColor: brandColors.tintsOffWhite60,
    display: 'flex',
    flexDirection: 'column',
    rowGap: spacing(3),
  },
  cardWrapper: {
    marginTop: spacing(3),
  },
  invisibleCard: {
    height: 0,
    marginTop: 'unset',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  buttonOverride: {
    width: '100%',
    [breakpoints.up('sm')]: {
      width: 'fit-content',
    },
  },
}));

export default useStyles;
